import { render } from "./Licitaciones.vue?vue&type=template&id=73604fa6&scoped=true"
import script from "./Licitaciones.vue?vue&type=script&lang=js"
export * from "./Licitaciones.vue?vue&type=script&lang=js"

import "./Licitaciones.vue?vue&type=style&index=0&id=73604fa6&lang=scss&scoped=true"
import "./Licitaciones.vue?vue&type=style&index=1&id=73604fa6&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73604fa6"]])

export default __exports__